<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { Button, Container, Modal, Text, Textarea } from '@Shelly/shelly-design-system';
	import { format } from '../../../services/i18n';
	import { capFirstChar } from '../../../helpers/utilities';

	export let message = '';
	export let showModal, mainText;
	export let revokeReqLoading = false;
	export let revokeInstallerAccess = false;

	const dispatch = createEventDispatcher();

	const onClose = () => {
		showModal = false;
		message = '';
	};
</script>

<Modal
	{showModal}
	on:close={onClose}
	title={revokeInstallerAccess
		? `${capFirstChar(
				$format('modal_revoke_installer_access_title', {
					default: 'Revoke Installer’s Access?',
				}),
			)}`
		: `${capFirstChar(
				$format('title_revoke_access', {
					default: 'Revoke Access',
				}),
			)}?`}
	removeScrollPadding
>
	<svelte:fragment slot="content">
		<Container padding="scrollPaddings">
			<Text>{mainText}</Text>
			{#if revokeInstallerAccess}
				<!-- DO NOT REMOVE COMMENT: Padding references -->
				<Textarea
					label={$format('textarea_installer_message', {
						default: 'Send a message to the installer if you want...',
					})}
					bind:value={message}
					class="mt-m mb-s"
					size="m"
					id="textarea-4p3mhr4"
					aria-labelledby="textarea-4p3mhr4"
				/>
			{/if}
		</Container>
	</svelte:fragment>

	<div slot="footer" class="d-flex justify-content-end">
		<Button
			variant="secondary"
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			on:click={onClose}
			responsiveSize={{
				sm: 'm',
			}}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			on:click={() => dispatch('revoke')}
			disabled={revokeReqLoading}
			responsiveSize={{
				sm: 'm',
			}}
		>
			{$format('button_revoke_access')}
		</Button>
	</div>
</Modal>
